import "../pages/CheckIn.css";
import { React, useState,useEffect,useRef } from "react";
import DatePicker, { DateObject } from 'react-multi-date-picker';
import {
  Box,
  Chip,
  Stack,
  Paper,
   Button,
   Typography
} from "@mui/material";
import { apiMain } from "../../App";
import { saveAs } from "file-saver";
import { DataGrid,GridToolbar   } from '@mui/x-data-grid';
import { useSnackbar } from "notistack";
import { useParams } from 'react-router-dom';
import { GetDataPromise, PostDataPromise } from "../Functions/SendingData";
import { Loading } from "../Loading";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { useReactToPrint } from "react-to-print";
import { useDemoData } from '@mui/x-data-grid-generator';
import { TableChart, PictureAsPdf, Print } from "@mui/icons-material";
import ExcelIcon from "../images/IconExcel";
const columns = [
    { field: 'id', headerName: 'ID', width: 90   ,  editable: false,},
 // { field: 'Reserv_Id', headerName: 'Id', width: 20 },
    {
    field: 'cust_id',
    headerName: 'cust_id ',
  //  description: 'This column has a value getter and is not sortable.',
    sortable: true,
    width: 150,
    editable: false,
    
    // valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
  },
  {
  field: 'cust_d_date',
  headerName: 'Date',
//  description: 'This column has a value getter and is not sortable.',
  sortable: true,
  width: 100,
  editable: false,
  // valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
},
  {
    field: 'cust_d_desc',
    headerName: 'Description ',
  //  description: 'This column has a value getter and is not sortable.',
    sortable: true,
    width: 400,
    editable: false,
    // valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
  },
  {
    field: 'cust_d_mab',
    headerName: 'Amount ₾',
  //  description: 'This column has a value getter and is not sortable.',
    sortable: true,
    width: 100,
    editable: false,
    // valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
  },

];
const paginationModel = { page: 0, pageSize: 5 };

function CostReport(props){
    const { item, applyValue, focusElementRef } = props;
    const gridRef = useRef();
  useEffect(() => {
    setFrom_Date(new DateObject());
    let newToDate = new DateObject();
    newToDate.add(10, "day");
    setTo_Date(newToDate);
 }, [])
 const handleFilterChange = (event, newValue) => {
    applyValue({ ...item, value: newValue });
  };
  const [value, setValue] = useState('1');
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
   const [Addflag,setAddflag]=useState(false);

 const InputRef = useRef(null)
 const [Room_No, setRoom_No] = useState(0);
 const changeRoom_No = (event) => {
    setRoom_No(event.target.value);
  };
  const getData = async ( ) => {

    let uparams = new URLSearchParams();
    uparams.append("From_Date", From_Date);
    uparams.append("To_Date", To_Date);
      let res = await GetDataPromise(`${apiMain}/api/v1/cust/selectcostreports?${uparams}`, true);
   let parsed = JSON.parse(res);
    console.log(parsed.status)
    if((parsed.status && parsed.status !== "error") || parsed.status === "success"){
        let newData = parsed.data;
      setData(newData)
        console.log(newData)
    }
 
}

 // const params = useParams()
  const [data, setData] = useState();
//    const { data,loading } = useDemoData({
//     dataSet: 'Commodity',
//     rowLength: 100,
//     maxColumns: 6,
//   });

  const { enqueueSnackbar } = useSnackbar();
  const [dialogLoading, setDialogLoading] = useState(false);
  const [dialogError, setDialogError] = useState({});
  //const [Reserv_Id, setReserv_Id] = useState(0);
 	const [Id, setId] = useState(0);
    const [From_Date, setFrom_Date] = useState();
    const [To_Date, setTo_Date] = useState();

    function handleCloseresturant() {
      props.ChangeXpage(0)
   }

const changeFrom_Date =(e)  =>{
  setFrom_Date(e.target.value)
  }
  const changeTo_Date =(e)  =>{
    setTo_Date(e.target.value)
    }
    const changesetId = (event) => {
      setId(event.target.value);
   };
     const handleSubmit = (e) => {
        e.preventDefault();
   
        // Add your form submission logic here
    };
  // 🧾 خروجی به Excel
  const exportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Report");
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });
    saveAs(blob, `CostReport_${new Date().toISOString()}.xlsx`);
  };

  // 🧾 خروجی به PDF
  const exportToPDF = () => {
    if (!data || data.length === 0) {
      enqueueSnackbar("No data to export", { variant: "warning" });
      return;
    }

    const doc = new jsPDF("p", "pt", "a4");
    doc.setFontSize(16);
    doc.text("Cost Report", 40, 30);
    doc.setFontSize(10);
    doc.text(
      `From: ${From_Date.format("YYYY-MM-DD")}  To: ${To_Date.format(
        "YYYY-MM-DD"
      )}`,
      40,
      45
    );

    const head = [["Name", "Last Name", "Passport", "Room", "Nights", "Account"]];
    const body = data.map((d) => [
      d.Pass_FName || "",
      d.Pass_LName || "",
      d.Pass_No || "",
      d.Room_Number || "",
      d.Night_No || "",
      d.Reserv_Account || "",
    ]);

    autoTable(doc, {
      head,
      body,
      startY: 60,
      theme: "striped",
      headStyles: { fillColor: [22, 160, 133], textColor: 255 },
      styles: { fontSize: 9, cellPadding: 3 },
    });

    doc.save(`CostReport_${new Date().toISOString()}.pdf`);
  };

  // 🖨 چاپ مستقیم
  const handlePrint = useReactToPrint({
    content: () => gridRef.current,
    documentTitle: "Cost Report",
  });


  const totalPrice = data?.reduce((acc, row) => acc + (row.cust_d_mab || 0), 0) || 0;


    return (
      

 
      <Box sx={{ p: 1}}>
      {/* 🔷 فیلترها و کنترل‌ها */}
      <Paper
        elevation={3}
        sx={{
          borderRadius: 2,
          p: 2,
          mb: 3,
          backgroundColor: "#fdfdfd",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: 2,
          height:40,
          marginTop:0,
        }}
      >
        {/* <Typography
          variant="h6"
          sx={{ mb: 1, color: "#2c3e50", fontWeight: "bold" }}
        >
          Agency Report Filter
        </Typography> */}
  
        <Stack
  direction="row"
  spacing={1} // ← فاصله کل Stack کمتر شد
  alignItems="center"
  sx={{ mb: 1, overflowX: "auto" }}
><Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>


                  <label  for="checkoutdate" style={{marginLeft:'10px'}}>From Date</label>
            
                   <DatePicker
                  style={{height:"35px", marginLeft:"10px"}}
                        // inputClass={"rmdp-input "+ classes + " " + className}
                        className={((window.innerWidth < 1550) ? "rmdp-mobile " : "")}
                        name="Checkoutdate"
                        required={true}
                        disabled={false}
                         calendarPosition="bottom"
                       //  format='YYYY-MM-dd'
                        // minDate={minDate}
                      //  calendar={gregorian} 
                        locale={"en"} 
                     value={From_Date} 
                  
                   onChange={(e) => setFrom_Date(e)}
                        // range={range}
                        // rangeHover={range}
                    />
                    </Box>
                    

  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                   <label  for="checkoutdate">   To Date</label>
                <DatePicker
                  style={{height:"35px",marginLeft:'0px',marginRight:'10px'}}
                        // inputClass={"rmdp-input "+ classes + " " + className}
                        className={((window.innerWidth < 1550) ? "rmdp-mobile " : "")}
                        name="Checkoutdate"
                        required={true}
                        disabled={false}
                         calendarPosition="bottom"
                       //  format='YYYY-MM-dd'
                        // minDate={minDate}
                      //  calendar={gregorian} 
                        locale={"en"} 
                     value={To_Date} 
                  
                   onChange={(e) => setTo_Date(e)}
                        // range={range}
                        // rangeHover={range}
                    />
                    </Box>
                      {/* <Chip label="Run" onClick={getData} color="primary" disabled={false} sx={{width:100 ,cursor:'pointer'}} />
     */}
  <Chip
    label="Run Report"
    onClick={getData}
    color="primary"
    sx={{
      cursor: "pointer",
      fontWeight: "bold",
      backgroundColor: "#16a085",
      color: "#fff",
    }}
  />
          
       
<Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
  <Button
    variant="contained"
    color="success"
    onClick={exportToExcel}
    sx={{ minWidth: 50, height: 35 }}
  >
     <ExcelIcon />
   
  </Button>
  </Box>
  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
  <Button
    variant="contained"
    color="error"
    onClick={exportToPDF}
    sx={{ minWidth: 50, height: 35 }}
  >
    <PictureAsPdf />
  </Button>
  </Box>
  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
  <Button
    variant="contained"
    sx={{ backgroundColor: "#34495e", minWidth: 50, height: 35 }}
    onClick={handlePrint}
  >
    <Print />
  </Button>
  </Box>
  
  </Stack>
  </Paper>
  {/* <div className="CheckIn" style={{float:'left', width:'800px',height:'330px',marginLeft:'10px',marginTop:'10px'}}> 
  */}

  {/* <DataGrid {...data} slots={{ toolbar: GridToolbar }} /> */}
  <Paper
  elevation={4}
  sx={{
    
    marginTop:-2,
    height: 300, // ارتفاع ثابت یا هر مقدار دلخواه
    borderRadius: 3,
  //  overflow: "auto", // اسکرول فعال برای فضای داخلی
    "& .MuiDataGrid-root": {
      border: "none",
      fontFamily: "Roboto, Vazirmatn, sans-serif",
    },
    "& .MuiDataGrid-columnHeaders": {
      backgroundColor: "#16a085",
    },
    "& .MuiDataGrid-columnHeader": {
      backgroundColor: "#16a085 !important",
      color: "#fff !important",
      fontWeight: "bold",
      fontSize: "12px",
      textAlign: "center",
      borderRight: "1px solid rgba(255,255,255,0.2)", // اختیاری برای زیبایی
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      whiteSpace: "normal",
      lineHeight: "1.4em",
    },
    "& .MuiDataGrid-cell": {
      color: "#2c3e50",
      fontSize: "12px",
      fontWeight: "bold",   //  ← پررنگ شدن داده‌ها
      borderBottom: "1px solid #ecf0f1",
    },
    "& .MuiDataGrid-row:nth-of-type(odd)": {
      backgroundColor: "#f9f9f9",
    },
    "& .MuiDataGrid-row:nth-of-type(even)": {
      backgroundColor: "#ffffff",
    },
    "& .MuiDataGrid-row:hover": {
      backgroundColor: "#e0f2f1",
    },
    "& .MuiDataGrid-footerContainer": {
      backgroundColor: "#f4f6f6",
      borderTop: "2px solid #d5dbdb",
    },
  }}
>
  <DataGrid
    rows={data}
    columns={columns}
    disableColumnMenu={false} // ← منو را فعال کن تا آیکون فیلتر ظاهر شود
    disableColumnSelector
    disableDensitySelector
    hideFooterSelectedRowCount
    filterMode="client" // ← فیلتر سمت کلاینت
    disableColumnFilter={false} // ← مطمئن شو فیلتر غیرفعال نیست
    // slots={{
    //   toolbar: GridToolbar, // ← نوار ابزار شامل فیلتر، جستجو و ...
    // }}
    slotProps={{
      toolbar: {
        showQuickFilter: true, // ← فیلتر سریع بالای جدول
        quickFilterProps: { debounceMs: 500 },
      },
    }}
    hideFooter // ← فوتر پیش‌فرض را مخفی می‌کند
    rowHeight={32} // ارتفاع ردیف‌ها
    headerHeight={36} // ارتفاع هدرها
    pagination={false} // غیرفعال کردن صفحه‌بندی
    autoHeight={false} // غیرفعال کردن ارتفاع خودکار
  />
{/* {  if (data!==undefined) */}
<Box
  sx={{
    display: "flex",
    justifyContent: "flex-end",
    gap: 2, // فاصله بین عناصر
    p: 1,
    color: "#2c3e50",
    fontSize: "12px",
    fontWeight: "bold",
  }}
>
  <Typography variant="body2">Rows: {data ? data.length : 0}</Typography>
  <Typography variant="body2">Total Price: {totalPrice.toLocaleString()}₾</Typography>
</Box>




</Paper>

    


  

</Box>
    
  
        
    );

}
export default CostReport;